import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=3227ab6d&"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports